<template>
  <div class="card floating">
    <div class="card-title">
      <h2>{{ $t('prompts.rename') }}</h2>
    </div>

    <div class="card-content">
      <p>{{ $t('prompts.renameMessage') }} <code>{{ oldName() }}</code>:</p>
      <input class="input input--block" v-focus type="text" v-model.trim="name">
    </div>

    <div class="card-action">
      <button class="button button--flat button--grey" id ="buttonCancelRename"
        @click="$store.commit('closeHovers')"
        :aria-label="$t('buttons.cancel')"
        :title="$t('buttons.cancel')">{{ $t('buttons.cancel') }}</button>
      <button @click="submit" id ="buttonRename"
        class="button button--flat"
        type="submit"
        :aria-label="$t('buttons.rename')"
        :title="$t('buttons.rename')">{{ $t('buttons.rename') }}</button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import { files as api } from '@/api';
import { ROUTES } from '@/router';

export default {
  name: 'rename',
  data: function () {
    return {
      name: '',
    };
  },
  created () {
    this.name = this.oldName();
  },
  mounted () {
    this.setIsDelete(true);
    this.setIsPrompt(true);
  },
  computed: {
    ...mapState(['req', 'selected', 'selectedCount', 'isDelete']),
    ...mapGetters(['isListing', 'isSharedDrive']),
  },
  methods: {
    ...mapMutations(['setIsPrompt', 'setIsDelete']),
    cancel: function () {
      this.$store.commit('closeHovers');
    },
    oldName: function () {
      if (this.isSharedDrive && window.location.hash === '') {
        if (this.req.items[this.selected[0]] !== null && this.selected.length !== 0) {
          return this.req.items[this.selected[0]].name;
        }
      }

      if (!this.isListing && this.$route.name !== ROUTES.DRIVE) {
        return this.req.name;
      }

      if (this.selectedCount === 0 || this.selectedCount > 1) {
        // This shouldn't happen.
        return;
      }

      if (this.req.items[this.selected[0]] !== null && this.selected.length !== 0) {
        return this.req.items[this.selected[0]].name;
      }

      if (this.selected.length === 0) {
        return this.req.name;
      }
      return;
    },
    submit: async function () {
      let oldLink = [];
      let newLink = '';
      
      if (this.$route.name === ROUTES.DRIVE || (this.isSharedDrive && window.location.hash == '')) {
        oldLink.push(this.req.items[this.selected[0]].handle);
      } else {
        const {nodeList} = await ibb.getSortedChildren(this.req.handle, Module.SortOrderType.SORT_ORDER_CREATION_TIME.value);
        // Retrieve virtually nested shared drives as well as native children in order to look for the nodes being renamed
        let nestedShares = await ibb.getSharedDrives();
        nestedShares = nestedShares.nodeList.filter(item => item.virtualParentHandle === this.req.handle && !item.archived);
        for (let item of [...nodeList, ...nestedShares]) {
          if (item.name === this.req.items[this.selected[0]].name) {
            oldLink.push(item.handle);
          }
        }
      }

      document.getElementById('buttonRename').disabled = true;
      document.getElementById('buttonCancelRename').disabled = true;
      newLink = this.name;

      try {
        await Promise.all(oldLink.map(item => {
          if (this.$route.name === ROUTES.DRIVE) {
            return api.renameId([{ from: item, to: newLink }], ibbLink);
          }
          return api.renameId([{ from: item, to: newLink }]);
        }));
      } catch (e) {
        this.$showError(e);
      }
      
      this.$store.commit('setReload', true);
      this.$store.commit('closeHovers');
      this.$store.commit('resetSelected');
    }
  },
  beforeDestroy () {
    this.setIsPrompt(false);
    this.setIsDelete(false);
  }
};
</script>
